import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import I18n from '../../../common/js/utils/I18n';
import Debug from '../../../common/js/utils/Debug';
import Config from '../../../common/js/utils/Config';
import PageSpinner from '../../../common/js/components/PageSpinner';
import withReducer from '../../../common/js/utils/WithReducer';
import { languageReducer } from '../../../api/actions/languageSlice';

/**
 * SelfSignUpLayout Component
 *
 * A layout component for self-signup flow pages.
 * Handles locale initialization.
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to render in the layout
 */
const SelfSignUpLayout = ({ children }) => {
  const browserLanguage = (navigator.language && navigator.language.split('-')[0]) || 'en';

  // Get language from Redux store with fallback
  const language = useSelector((state) =>
    state.language ? state.language.selectedLanguage : localStorage.getItem('language') || browserLanguage,
  );

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    initLocale();
  }, [language]);

  const initLocale = () => {
    const basePath = Config.getAssetBase();
    Debug.log('[SelfSignUpLayout] initLocale called with language:', language, 'basePath:', basePath);
    setLoading(true);
    I18n(language, basePath)
      .then(() => {
        Debug.log('[SelfSignUpLayout] I18n loaded successfully');
        Debug.log('[SelfSignUpLayout] Loading non-English language:', language);
        document.title = Config.get('adminXProductName', true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) {
    return <PageSpinner />;
  }

  return <div className='self-signup-layout'>{children}</div>;
};

SelfSignUpLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

// Inject language reducer dynamically
export default withReducer({
  [languageReducer.name]: languageReducer.reducer,
})(SelfSignUpLayout);
